import AuthService from "./auth";

class ApiService {
    get endpoint() {
        return "https://shapezio-analytics.herokuapp.com";
    }

    /**
     * @param {string} token
     */
    checkAuthToken(token) {
        return this.query("select true", {}, token).then(
            () => true,
            () => false
        );
    }

    /**
     *
     * @param {string} query
     * @param {Object.<string, any>=} parameters
     * @param {string=} accessKey
     */
    query(query, parameters = {}, accessKey = AuthService.authToken) {
        console.debug("Fetching", query);
        const start = performance.now();

        return fetch(this.endpoint + "/v1/query", {
            method: "POST",
            cache: "no-cache",
            headers: {
                "X-Api-Key": "baf6a50f0cc7dfdec5a0e21c88a1c69a4b34bc4a",
                "Content-type": "application/json",
            },
            body: JSON.stringify({
                parameters,
                query,
                accessKey,
            }),
        })
            .then(res => {
                if (!res.ok) {
                    throw new Error("Bad status: " + res.status + " " + res.statusText);
                }
                return res;
            })
            .then(res => res.json())
            .then(res => {
                if (res.error) {
                    throw new Error("API Error: " + res.error);
                }
                const duration = performance.now() - start;
                console.log(" -> ", Math.round(duration), "ms");
                return res.response.rows;
            });
    }
}

export default new ApiService();
